import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { UitkCard } from 'uitk-react-cards';

// Components
import { ReviewsSummaryCompressed } from 'components/infosite/property-details/reviews-summary-compressed';
import { LocalizedPropertyDetailsProps } from './index';
import { StaticGalleryMosaic } from 'components/infosite/static-gallery-mosaic';
import { WhatsAroundMap } from 'components/infosite/whats-around/whats-around-map';

@inject('routeStore', 'analytics', 'currentHotel')
@observer
export class RoninPropertyDetails extends React.Component<LocalizedPropertyDetailsProps> {
  public render() {
    const { defaultData, currentHotel, gallery, mapModel } = this.props;

    const whatsAroundModel = currentHotel.hotel && currentHotel.hotel.locationInfo && currentHotel.hotel.locationInfo.whatsAroundModule;
    const mapSrc = whatsAroundModel && whatsAroundModel.mapImageUrl;

    /**
     * This is a bit of a hack to set a loaded state once we have data back for these items - the class name indicates
     *  we can remove the min-height on the container that avoids display jank/bounciness.
     */
    const status: string = defaultData ? 'initialized' : 'loaded';
    const cardClassName = `property-details all-b-margin-three ${status} all-x-padding-three all-y-padding-three`;

    return (
      <div itemScope={true} itemType="https://schema.org/Hotel">
        <UitkCard className={`${cardClassName} uitk-flat-border-top all-t-margin-two`}>
          <div className="uitk-grid uitk-cell all-y-padding-three all-x-gutter-three all-y-gutter-three">
            <section className="uitk-cell uitk-card-media all-cell-1-1">
              <StaticGalleryMosaic gallery={gallery} />
            </section>
            <section className="uitk-cell s-cell-1-1 m-cell-1-1 l-cell-1-3 xl-cell-1-3">
              <UitkCard withBorder={true} className="all-y-padding-one all-x-padding-one">
                <WhatsAroundMap src={mapSrc} mapModel={mapModel} />
              </UitkCard>
            </section>
            <section className="uitk-cell s-cell-1-1 m-cell-1-1 l-cell-2-3 xl-cell-2-3">
              <UitkCard withBorder={true} className="all-y-padding-one all-x-padding-one">
                <ReviewsSummaryCompressed />
              </UitkCard>
            </section>
          </div>
        </UitkCard>
      </div>
    );
  }
}
